import React from 'react';
import { useEffect, useState } from 'react';
import classNames from 'classnames';

import { ReactComponent as CloseIcon } from 'assets/icons/close.svg';

import './Toast.css';

const Toast = ({ duration, message, onClose, type }) => {
	const [enter, setEnter] = useState(false);
	const [exit, setExit] = useState(false);

	const animationDuration = 300; // match this with CSS transition duration

	useEffect(() => {
		const enterTimer = setTimeout(() => {
			setEnter(true);
		}, 10);

		let closeTimer;
		if (duration) {
			closeTimer = setTimeout(() => {
				setExit(true);
				setTimeout(() => {
					onClose();
				}, animationDuration);
			}, duration);
		}

		return () => {
			clearTimeout(enterTimer);
			if (closeTimer) {
				clearTimeout(closeTimer);
			}
		};
	}, [duration, onClose]);

	const handleClick = () => {
		setExit(true);
		setTimeout(() => {
			onClose();
		}, animationDuration);
	};

	const typeClasses = {
		Error: 'bg-sfi-red text-white',
		Warning: 'bg-yellow-500 text-white',
		Info: 'bg-sfi-blue text-white',
	};

	return (
		<div
			className={classNames(
				'fixed top-0 left-0 w-full p-4 z-[300] transition-transform duration-300 -translate-y-full',
				{
					'translate-y-0': enter && !exit,
					'-translate-y-full': exit,
				},
				typeClasses[type] || ''
			)}
		>
			<div className="flex justify-between items-center w-full">
				<span className="whitespace-pre-line">{message}</span>
				<div className="mr-2 cursor-pointer" onClick={handleClick}>
					<CloseIcon />
				</div>
			</div>
		</div>
	);
};

export default Toast;
